<template>
  <div class="app-modal-overlay">
    <div class="app-modal-wrapper">
      <div class="app-modal-leave-modal" v-if="closeButton" @click="cancel">
        <img src="@/Common/Icons/XmarkModal.png" alt="Logo" />
      </div>
      <div class="app-modal-header">
        <slot name="app-modal-header"></slot>
      </div>
      <div class="app-modal-body-wrapper">
        <div class="app-modal-body">
          <slot name="app-modal-body"></slot>
        </div>
      </div>
      <div class="app-modal-footer">
        <slot name="app-modal-footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSetPrice",
  props: {
    closeButton: {
      type: Boolean,
      default: false,
    },
    cancel: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/appSetPriceModal.scss"></style>
